/**
 * Odredište nakon prijave - svi oblici prijave (stranica za prijavu, bočni izbornik za prijavu, forma za prijavu)
 * moraju koristiti isto odredište ("targetPath") i isti tip ("redirectType").
 */

// URL s našeg sitea koji nije trenutna stranica
export const isOwnSiteURL = (url) => typeof window !== 'undefined'
    && typeof url === 'string'
    && url !== ''
    && url.includes(window.location.host)
    && url !== window.location.href;

const getQueryParameter = (name) => (typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get(name)
    : null);

export const getExplicitRedirectURL = () => {
    const redirectURL = getQueryParameter('redirectURL');

    return isOwnSiteURL(redirectURL) ? redirectURL : null;
};

export const getExplicitRedirectType = () => getQueryParameter('type') || '';

export const getPreviousOwnSitePageURL = () => (typeof document !== 'undefined' && isOwnSiteURL(document.referrer)
    ? document.referrer
    : null);
